/**
 * WEB-2451 п.2: разбор ссылки на ролик YouTube/Vimeo — ОДИН на отрисовку
 * (`VideoEmbedRenderer.tsx`) и панель свойств (`properties/by-type/video_embed.tsx`),
 * чтобы предупреждение «ссылка не распознана» в панели и пустой блок у
 * посетителя не разошлись.
 *
 * Виды: `youtube.com/watch?v=`, `youtu.be/`, `youtube.com/shorts/`,
 * `youtube.com/embed/`, `youtube-nocookie.com/embed/` (идентификатор — 11
 * знаков) и `vimeo.com/<число>`. Прямой файл видео — не здесь, его узнаёт
 * `./videoFile.ts` (`isVideoFileUrl`).
 */

/** WEB-956: разобранная ссылка на ролик — провайдер + id. */
export type ParsedVideo = { provider: 'youtube' | 'vimeo'; id: string };

const YOUTUBE_ID = '([a-zA-Z0-9_-]{11})';
const YOUTUBE = new RegExp(
  `(?:youtube\\.com\\/watch\\?v=|youtu\\.be\\/|youtube\\.com\\/shorts\\/|(?:youtube|youtube-nocookie)\\.com\\/embed\\/)${YOUTUBE_ID}`,
);

export function parseVideoEmbed(url: string): ParsedVideo | null {
  if (!url) return null;
  const ytMatch = url.match(YOUTUBE);
  if (ytMatch) return { provider: 'youtube', id: ytMatch[1] };
  const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
  if (vimeoMatch) return { provider: 'vimeo', id: vimeoMatch[1] };
  return null;
}
